import {useQuery} from "@apollo/client";
import {useMemo, useState} from "react";
import {useFormContext} from "react-hook-form";

import {ServiceField} from "@/lib/constants/service.ts";
import {CloudStatusMetasCount, GQL_THIRD_PARTY_COMPONENTS_COUNT} from "@/lib/queries/checks.ts";
import {ThirdPartyServiceComponent} from "@/lib/types/checks.ts";
import {ThirdPartyNameField} from "@/pages/checks/components/form/fields/ThirdPartyNameField.tsx";
import {ThirdPartySelectField} from "@/pages/checks/components/form/fields/ThirdPartySelectField.tsx";

export const CheckThirdPartyForm = () => {
  const {data, loading, previousData} = useQuery<CloudStatusMetasCount>(GQL_THIRD_PARTY_COMPONENTS_COUNT);
  const currentData = loading ? previousData : data;
  const currentCount = useMemo(() => currentData?.cloudStatusMetasCount.count || 0, [currentData]);

  const {watch, setValue} = useFormContext();
  const selectedThirdPartyServiceComponentID = watch("selected_third_party_service_component_id");
  const selectedThirdPartyServiceComponent = watch("selected_third_party_service_component");
  const checkId = watch(ServiceField.ID);
  const [thirdPartyServiceComponent, setThirdPartyServiceComponent] = useState(
    selectedThirdPartyServiceComponent || null
  );
  const setThirdPartyComponent = (thirdPartyServiceComponent: ThirdPartyServiceComponent | null) => {
    if (checkId) {
      return;
    }
    if (thirdPartyServiceComponent && selectedThirdPartyServiceComponentID == thirdPartyServiceComponent.id) {
      setValue("selected_third_party_service_component_id", null, {shouldDirty: true, shouldValidate: true});
      setValue(ServiceField.NAME, null, {shouldDirty: true, shouldValidate: true});
      setThirdPartyServiceComponent(null);
    } else if (thirdPartyServiceComponent) {
      setValue("selected_third_party_service_component_id", thirdPartyServiceComponent.id, {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(ServiceField.NAME, thirdPartyServiceComponent.name, {shouldDirty: true, shouldValidate: true});
      setThirdPartyServiceComponent(thirdPartyServiceComponent);
    }
  };

  return (
    <div className="pulseMaxWidthL mt-4">
      <div id="thirdPartyServices">
        <ThirdPartyNameField
          placeholder={
            "Search " +
            (currentCount ? Math.floor(currentCount / 1_000) + "K+" : "") +
            " third party components, or browse the most popular below."
          }
          thirdPartyServiceComponent={thirdPartyServiceComponent}
          setThirdPartyServiceComponent={setThirdPartyComponent}
        />
      </div>
      {!checkId && (
        <div className="mt-4">
          <ThirdPartySelectField onChange={setThirdPartyComponent} />
        </div>
      )}
    </div>
  );
};
